import createIcon from '../../createIcon';

/**
 * @component @name BikeScooter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMTRIMTAuNzRMOC44MiA1LjU2QzguNjEgNC42NSA3LjggNCA2Ljg3IDRIM1Y2SDYuODdMOC4yOSAxMi4yNUg4LjI4QzYuMTIgMTIuOSA0LjQ3IDE0LjczIDQuMDkgMTdIMFYxOUg2VjE4QzYgMTUuNzkgNy43OSAxNCAxMCAxNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOSA4SDE4LjE4TDE2LjgzIDQuMzFDMTYuNTUgMy41MiAxNS44IDMgMTQuOTYgM0gxMVY1SDE0Ljk2TDE2LjA2IDhIMTAuNEwxMC44NiAxMEgxNUMxNC41NyAxMC41OCAxNC4yNSAxMS4yNSAxNC4xIDEySDExLjMxTDExLjc3IDE0SDE0LjFDMTQuNTQgMTYuMjMgMTYuNDEgMTcuODggMTguNzUgMTcuOTlDMjEuNTUgMTguMTIgMjQgMTUuOCAyNCAxMi45OUMyNCAxMC4yIDIxLjggOCAxOSA4Wk0xOSAxNkMxNy4zMiAxNiAxNiAxNC42OCAxNiAxM0MxNiAxMi4wNyAxNi40MSAxMS4yNyAxNy4wNSAxMC43MkwxOC4wMSAxMy4zNkwxOS44OSAxMi42OEwxOC45MiAxMC4wMUMxOC45NSAxMC4wMSAxOC45OCAxMCAxOS4wMSAxMEMyMC42OSAxMCAyMi4wMSAxMS4zMiAyMi4wMSAxM0MyMi4wMSAxNC42OCAyMC42OCAxNiAxOSAxNloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMCAxNUM4LjM0IDE1IDcgMTYuMzQgNyAxOEM3IDE5LjY2IDguMzQgMjEgMTAgMjFDMTEuNjYgMjEgMTMgMTkuNjYgMTMgMThDMTMgMTYuMzQgMTEuNjYgMTUgMTAgMTVaTTEwIDE5QzkuNDUgMTkgOSAxOC41NSA5IDE4QzkgMTcuNDUgOS40NSAxNyAxMCAxN0MxMC41NSAxNyAxMSAxNy40NSAxMSAxOEMxMSAxOC41NSAxMC41NSAxOSAxMCAxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BikeScooter = createIcon('BikeScooter', [
  [
    'path',
    {
      d: 'M10 14H10.74L8.82 5.56C8.61 4.65 7.8 4 6.87 4H3V6H6.87L8.29 12.25H8.28C6.12 12.9 4.47 14.73 4.09 17H0V19H6V18C6 15.79 7.79 14 10 14Z',
      key: '1phqr3',
    },
  ],
  [
    'path',
    {
      d: 'M19 8H18.18L16.83 4.31C16.55 3.52 15.8 3 14.96 3H11V5H14.96L16.06 8H10.4L10.86 10H15C14.57 10.58 14.25 11.25 14.1 12H11.31L11.77 14H14.1C14.54 16.23 16.41 17.88 18.75 17.99C21.55 18.12 24 15.8 24 12.99C24 10.2 21.8 8 19 8ZM19 16C17.32 16 16 14.68 16 13C16 12.07 16.41 11.27 17.05 10.72L18.01 13.36L19.89 12.68L18.92 10.01C18.95 10.01 18.98 10 19.01 10C20.69 10 22.01 11.32 22.01 13C22.01 14.68 20.68 16 19 16Z',
      key: '1rz6u7',
    },
  ],
  [
    'path',
    {
      d: 'M10 15C8.34 15 7 16.34 7 18C7 19.66 8.34 21 10 21C11.66 21 13 19.66 13 18C13 16.34 11.66 15 10 15ZM10 19C9.45 19 9 18.55 9 18C9 17.45 9.45 17 10 17C10.55 17 11 17.45 11 18C11 18.55 10.55 19 10 19Z',
      key: '1ty4ij',
    },
  ],
]);

export default BikeScooter;
